import { Button, SecondaryButton, typography } from '@joor/design-system'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import Loader from 'components/Core/Loader/Loader'

export const Footer = styled.div`
  display: grid;
  grid-template-columns: 3fr 5fr 2fr 1fr;
  grid-template-areas: ' . stepIndicator back next';
  grid-template-rows: 1fr;
  margin-top: 16px;
  justify-items: center;
`

export const ActionButton = styled(Button)`
  grid-area: next;
  justify-self: center;
`

export const ImportingLoader = styled(Loader)`
  grid-area: next;
  justify-self: center;
`

export const ButtonBack = styled(SecondaryButton)`
  grid-area: back;
  justify-self: center;
`

export const HorizontalLine = styled.hr`
  margin: 8px 0 16px;
  border-top: 1px solid var(--color-neutral-300);
`

export const HeadingLabel = styled.div`
  ${typography.alpha.primaryActive.body2}
  margin-top: 7px;
  transform: translateY(40%);
`

export const ErrorsLabel = styled.label`
  ${typography.alpha.error.body3};
  color: var(--color-error-500) !important;
  display: block;
  text-align: right;
`

export const LinkToJobs = styled(Link)`
  color: var(--color-neutral-600) !important;
`

export const RedirectText = styled.p`
  color: var(--color-secondary-800) !important;
`
